import { render } from "./logs-page-difference-dialog.vue?vue&type=template&id=b866d6b2&ts=true"
import script from "./logs-page-difference-dialog.ts?vue&type=script&lang=ts"
export * from "./logs-page-difference-dialog.ts?vue&type=script&lang=ts"

import "./logs-page-difference-dialog.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__